import { Flex, Heading, SimpleGrid, Text, VStack } from "@chakra-ui/react";
import { Pill, PrimaryBtn, Reveal, Section, Step, TEAL_DARK } from "./utils";

const HowItWorks = () => (
  <Section bg="white" id="how">
    <VStack gap={10}>
      <Reveal>
        <VStack gap={3} textAlign="center" maxW="500px" mx="auto">
          <Pill>Hogyan működik?</Pill>
          <Heading
            fontSize={{ base: "xl", md: "2xl" }}
            color={TEAL_DARK}
            letterSpacing="-0.02em"
          >
            Pillanatok alatt elindulsz
          </Heading>
          <Text color="gray.500" lineHeight={1.7}>
            Gyors, egyszerű, olcsó. Tudd meg, hogyan érheted el, hogy bárki
            könnyedén foglalhasson nálad.
          </Text>
        </VStack>
      </Reveal>

      <SimpleGrid columns={{ base: 1, md: 3 }} gap={8} w="full">
        <Step
          num="01"
          title="Beállítod az oldaladat"
          body="Létrehozod a szolgáltatásaidat, megadod az időpontokat, testre szabod a foglalóoldaladat – 1 órán belül."
          delay={0}
        />
        <Step
          num="02"
          title="Megosztod a linkedet"
          body="Kimásolod az egyedi linkedet, és megosztod ügyfeleiddel – közösségi médiában, e-mailen, honlapon."
          delay={0.1}
        />
        <Step
          num="03"
          title="Jönnek a foglalások"
          body="Az ügyfél választ egy számára megfelelő időpontot. Te értesítést kapsz, ő visszaigazolást kap. Kész."
          delay={0.2}
        />
      </SimpleGrid>

      <Reveal delay={0.1}>
        <Flex justify="center" pt={4}>
          <PrimaryBtn href="https://app.wobble.hu/signup_page">
            Kipróbálom ingyen
          </PrimaryBtn>
        </Flex>
      </Reveal>
    </VStack>
  </Section>
);

export default HowItWorks;
